import { useBrokerFirm } from 'queries/broker/useBrokerFirm';
import { useAuth } from 'providers';
import { isStrideUpInternalFirm } from 'utils/strideUpInternalFirm';

export function useIsIntroducerSectionEligible() {
  const { data: firm, isLoading: isFirmLoading } = useBrokerFirm();
  const { isLoaded, isSignedIn } = useAuth();

  const isEligible = Boolean(isSignedIn && isLoaded && isStrideUpInternalFirm(firm));

  return {
    isEligible,
    isLoading: isFirmLoading || !isLoaded,
  };
}
